import { Box, Typography } from "@mui/material";
import Lottie from "lottie-react";
import React from "react";
import animationData from "./BoxpayLogo.json";

function LoadingLogoPage({ minHeight }) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "center",
        textAlign: "center",
        minHeight: minHeight || `calc(100vh - 68px)`,
      }}
    >
      <Lottie
        animationData={animationData}
        loop={true}
        autoplay={true}
        style={{ width: "48px", height: "48px" }}
        speed={4.5}
      />
      <Typography
        className="bodyB2Medium greyColor"
        sx={{ marginTop: "15px !important" }}
      >
        Loading...
      </Typography>
    </Box>
  );
}

export default LoadingLogoPage;
